/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have an idea for a tool you'd love to see, or hit a bug? Let us know — your input shapes what we build next.`)
};

const es_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes una idea para una herramienta que te encantaría ver o encontraste un error? Cuéntanoslo: tus comentarios definen lo que construiremos a continuación.`)
};

const de_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du eine Idee für ein Tool, das du gerne sehen würdest, oder einen Fehler entdeckt? Sag es uns — dein Feedback bestimmt, was wir als Nächstes entwickeln.`)
};

const nl_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heb je een idee voor een tool die je graag zou zien, of een bug gevonden? Laat het ons weten — jouw input bepaalt wat we hierna bouwen.`)
};

const fr_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez une idée d'outil que vous aimeriez voir, ou vous avez rencontré un bug ? Dites-le-nous — vos retours façonnent ce que nous construirons ensuite.`)
};

const it_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai un'idea per uno strumento che vorresti vedere o hai trovato un bug? Faccelo sapere: i tuoi suggerimenti definiscono cosa costruiremo dopo.`)
};

const pt_br2_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem uma ideia de ferramenta que gostaria de ver ou encontrou um bug? Conte para a gente — sua opinião define o que vamos construir a seguir.`)
};

const pt_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tens uma ideia para uma ferramenta que gostarias de ver ou encontraste um erro? Diz-nos — a tua opinião define o que vamos construir a seguir.`)
};

const ja_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見てみたいツールのアイデアや、見つけた不具合はありますか？お知らせください。皆さんの声が次に作るものを決めます。`)
};

const zh_contact_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有想看到的工具创意，或者遇到了 bug？告诉我们——你的反馈将决定我们接下来做什么。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_subtitle", locale)
	if (locale === "en") return en_contact_subtitle(inputs)
	if (locale === "es") return es_contact_subtitle(inputs)
	if (locale === "de") return de_contact_subtitle(inputs)
	if (locale === "nl") return nl_contact_subtitle(inputs)
	if (locale === "fr") return fr_contact_subtitle(inputs)
	if (locale === "it") return it_contact_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_contact_subtitle(inputs)
	if (locale === "pt") return pt_contact_subtitle(inputs)
	if (locale === "ja") return ja_contact_subtitle(inputs)
	return zh_contact_subtitle(inputs)
};